import usePost from '../usePost';
import useGet from '../useGet';
import {IQueryByIdParams} from '../../utils/HttpInstance';
import {Moment} from 'moment';

export enum UserCategory {
  小学组 = 1,
  中学组 = 2,
}

export enum UserGender {
  女 = 1,
  男 = 2,
}

export enum UserGrade {
  一年级 = 1,
  二年级 = 2,
  三年级 = 3,
  四年级 = 4,
  五年级 = 5,
  预初 = 6,
  初一 = 7,
  初二 = 8,
  初三 = 9,
  高一 = 10,
  高二 = 11,
  高三 = 12,
}

export enum UserType {
  普通账号 = 1,
  评审员 = 2,
  管理员 = 3,
}

export interface IUser {
  userName: string;
  legalName: string;
  category: UserCategory;
  gender: UserGender;
  schoolName: string;
  grade: UserGrade;
  classNo: number;
  coachName: string;
  telephone: string;
  remark: string;
  type: UserType;
  birthDate: string;
  id: number;
  createdTime: Date;
}

export interface ISession {
  token: string;
  user: IUser;
}

export interface IUserRegisterParams {
  userName: string;
  passwordMd5: string;
}

export interface IUserLoginParams {
  userName: string;
  passwordMd5: string;
}

export interface IUserLoginParams {
  userName: string;
  passwordMd5: string;
}

export interface IUserQueryByTokenParams {
  token: string;
}

export interface IUserUpdateProfileParams {
  id: number;
  legalName: string;
  category: UserCategory;
  gender: UserGender;
  schoolName: string;
  grade: UserGrade;
  classNo: number;
  coachName: string;
  telephone: string;
  birthDate: Moment;
  remark: string;
}
export interface GetExcelTemplateResponse {
  url: string;
}
export interface IUserUpdatePasswordParams {
  passwordMd5: string;
}
export interface ExcelImportResponse {
  errorMessage: string;
  errorExcelUrl: string;
  addCount: number;
  passCount: number;
}
export default class UseUser {
  static register() {
    return usePost<IUserRegisterParams, IUser>('user/register', {});
  }
  static updatePassword() {
    return usePost<IUserUpdatePasswordParams, any>('system/updatePassword', {});
  }
  static login() {
    return usePost<IUserLoginParams, ISession>('user/login', {});
  }
  static updateProfile() {
    return usePost<IUserUpdateProfileParams, IUser>('user/updateProfile', {});
  }
  static queryByToken() {
    return useGet<IUserQueryByTokenParams, IUser>('user/queryByToken', {});
  }
  static list() {
    return useGet<void, IUser[]>('user/list', {});
  }
  static queryById() {
    return useGet<IQueryByIdParams, IUser>('user/queryById', {});
  }
  static getExcelTemplate() {
    return useGet<void, GetExcelTemplateResponse>('user/getExcelTemplate', {});
  }
}
